export type BillingsCargoTaxiUpdateRequestBillingNode = {
  id: string;
  nodeId: string;
  checkoutEventId?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinated: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export enum BillingsCargoTaxiUpdateRequestBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsCargoTaxiUpdateRequestBillingContributionBaseAmount = {
  type: BillingsCargoTaxiUpdateRequestBillingContributionType.BASE_AMOUNT;
  comment?: string;
  distance: number;
  rate: number;
};

export type BillingsCargoTaxiUpdateRequestBillingContributionChargeHaltings = {
  type: BillingsCargoTaxiUpdateRequestBillingContributionType.CHARGE_HALTING;
  comment?: string;
  distance: number;
  amount: number;
};

export type BillingsCargoTaxiUpdateRequestBillingContributionContractCorrectionPercentage =
  {
    type: BillingsCargoTaxiUpdateRequestBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsCargoTaxiUpdateRequestBillingContributionDiscountOptimization =
  {
    type: BillingsCargoTaxiUpdateRequestBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiUpdateRequestBillingContributionDiscountBeingLate =
  {
    type: BillingsCargoTaxiUpdateRequestBillingContributionType.DISCOUNT_BEING_LATE;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiUpdateRequestBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsCargoTaxiUpdateRequestBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiUpdateRequestBillingContributionDiscountOther = {
  type: BillingsCargoTaxiUpdateRequestBillingContributionType.DISCOUNT_OTHER;
  comment?: string;
  amount: number;
};

export type BillingsCargoTaxiUpdateRequestBillingContribution =
  | BillingsCargoTaxiUpdateRequestBillingContributionBaseAmount
  | BillingsCargoTaxiUpdateRequestBillingContributionChargeHaltings
  | BillingsCargoTaxiUpdateRequestBillingContributionContractCorrectionPercentage
  | BillingsCargoTaxiUpdateRequestBillingContributionDiscountOptimization
  | BillingsCargoTaxiUpdateRequestBillingContributionDiscountBeingLate
  | BillingsCargoTaxiUpdateRequestBillingContributionDiscountIncompatibleCar
  | BillingsCargoTaxiUpdateRequestBillingContributionDiscountOther;

export type BillingsCargoTaxiUpdateRequestBody = {
  billingNodes: BillingsCargoTaxiUpdateRequestBillingNode[];
  billingContributions: BillingsCargoTaxiUpdateRequestBillingContribution[];
};

type BillingsCargoTaxiUpdateRequest = {
  billingUuid: string;
  billingNodes: BillingsCargoTaxiUpdateRequestBillingNode[];
  billingContributions: BillingsCargoTaxiUpdateRequestBillingContribution[];
};

export default BillingsCargoTaxiUpdateRequest;
